enum AddressCertificationStatus {
    NonCertified = 'NonCertified',
    Certified = 'Certified',
    Overridden = 'Overridden',
    Unresolved = 'Unresolved',
}

export default AddressCertificationStatus;
